import { NuxtApp } from '@nuxt/types/app'
import defaultTheme from './themes'
import { PromoThemeOptions } from '~/core/config/promo-theme/types'

export function getPromoTheme (_ctx: NuxtApp): PromoThemeOptions {
  return defaultTheme.options
}
